module.exports = __webpack_public_path__ + "static/media/wide.669f1cfc.jpg";